import type { Observable } from 'rxjs';

import type {
  AnalyticsAPIMethods,
  AnalyticsClientOptions,
  AnalyticsIntegrations,
} from './analytics.types';

export abstract class AnalyticsAdapter {
  public abstract load(
    key: string,
    options?: AnalyticsClientOptions,
  ): Observable<AnalyticsAPIMethods | null>;

  protected shouldSendTo(
    targetIntegration: AnalyticsIntegrations,
    opts?: AnalyticsClientOptions,
  ): boolean {
    const integrations = opts?.integrations ?? {};
    const all = integrations.All ?? true;
    const integration = integrations[targetIntegration];
    return (all && integration !== false) || !!integration;
  }
}
